import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

export class MacDetails {
    macTelFlag : string;
    macAddresses : MacAddress[];
    remarks : string;
}

export class MacAddress {}

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class MacDetailsService {
  constructor(private http: HttpClient) {}

  getMacDetails(custId : any): Observable<any> {
    const get_url = baseApiUrl + 'subscriber/getMacDetails/' + custId;
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res as MacDetails[]),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  insertMacDetails(macDetails_id : any,resetmac) : Observable<any> {
      const post_url = baseApiUrl + 'subscriber/resetMac/' + macDetails_id;
      return this.http.post<any>(post_url,resetmac, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
    }
  
    updateMacDetails(macDetails_data : any) : Observable<any> {
      const post_url = baseApiUrl + 'subscriber/updateMacDetails';
      return this.http.post<any>(post_url, macDetails_data, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
    }
}